import React from 'react'
import Typewriter from 'typewriter-effect';
import WordGraph from './WordGraph'


const UniComment = (props) => {
  var summarize = "<p>" + props.data.summarize + "</p>"

  return (
    <div style={{width:"45%",boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
    padding: "5%"}}>

      <h2>{props.data.name}</h2>
      {
        "keywords" in props.data && <div><h4 style={{"marginTop":"30px"}}>Topic Modelling</h4>
            <WordGraph data={props.data.keywords}/>
        </div>
      }
      
      <h4 style={{"marginTop":"30px"}}>Summarized Content </h4>
      <Typewriter
        onInit={(typewriter) => {
          typewriter.typeString(summarize)
            .callFunction(() => {
              console.log('String typed out!');
            })
            // .delay(1500)
            .pauseFor(2500)
            // .deleteAll()
            .callFunction(() => {
              console.log('All strings were deleted');
            })
            .start();
        }}
        />
        
    </div>
  )
}

export default UniComment
